
<div class="flexRow paginationContainer" v-if="pageList.length > 0">
  <div class="main">
    <div class="mr20">
      共 {{ totalPages }} 页/
      <span class="totalNum">{{ total }}</span>
      条数据
    </div>
    <div
      class="mr20 cursor prev"
      :class="{ disabled: currentPage === 1 }"
      @click="handlePrevPage"
    >
      上一页
    </div>
    <ul>
      <li
        v-for="(page, index) in pageList"
        :key="index"
        @click="handlePageClick(page)"
        :class="{ active: currentPage == page, disabled: page === '...' }"
      >
        {{ page }}
      </li>
    </ul>
    <div
      class="mr20 cursor next"
      :class="{ disabled: currentPage === totalPages }"
      @click="handleNextPage"
    >
      下一页
    </div>
    <span class="ml20">跳至</span>
    <input v-model="jumpPage" @blur="handleJumpPage" @keydown.enter="handleJumpPage" />
    <span class="ml10">页</span>
  </div>
</div>
